
import { InputNumber } from 'element-ui'

export default {
  extends: InputNumber,
}
